import { defineComponent as _defineComponent } from 'vue'
import Icon from '@components/Icon.vue';

import { faInfoCircle as faInfoRegular } from '@icons/regular/faInfoCircle';
import { faInfoCircle as faInfoSolid } from '@icons/solid/faInfoCircle';

declare module 'vue/types/vue' {
  export interface Vue {
    InfoCircle: ComponentWithProps<Props>;
  }
}

export type Placement =
  | 'auto'
  | 'top'
  | 'bottom'
  | 'left'
  | 'right'
  | 'topleft'
  | 'topright'
  | 'bottomleft'
  | 'bottomright'
  | 'lefttop'
  | 'leftbottom'
  | 'righttop'
  | 'rightbottom';

/**
 * `InfoCircle` component properties.
 */
export interface Props {
  text: string;
  /**
   * Applies one of the Bootstrap theme color variants to the component.
   */
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
  /**
   * How to position the tooltip. When `auto` is specified, it will dynamically
   * reorient the tooltip.
   */
  placement?: Placement;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoCircle',
  props: {
    text: null,
    variant: null,
    placement: { default: 'top' }
  },
  setup(__props: any) {



return { __sfc: true,Icon, faInfoRegular, faInfoSolid }
}

})